import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { ButtonModule } from '@appkit4/angular-components/button';
import { ComboboxModule } from '@appkit4/angular-components/combobox';
import { DropdownModule } from '@appkit4/angular-components/dropdown';
import { FieldModule } from '@appkit4/angular-components/field';
import { MultipleDropdownModule } from '@appkit4/angular-components/multiple-dropdown';
import { SingleDropdownModule } from '@appkit4/angular-components/single-dropdown';
import { SliderModule } from '@appkit4/angular-components/slider';
import { TagModule } from '@appkit4/angular-components/tag';
import { UiCommonModule } from '@shared/modules/ui-common/ui-common.module';

import { PanelModule } from '@appkit4/angular-components/panel';
import { DropDownAppkitOverlayListFixDirective } from '@shared/directives/appkit-dropdown-list-overlay-fix.directive';
import { ComboboxFilterComponent } from './components/combobox-filter/combobox-filter.component';
import { DatepickerFilterComponent } from './components/datepicker-filter/datepicker-filter.component';
import { DefaultTextfieldFilterComponent } from './components/default-textfield-filter/default-textfield-filter.component';
import { DropdownFilterComponent } from './components/dropdown-filter/dropdown-filter.component';
import { GridFilterComponent } from './components/grid-filter/grid-filter.component';
import { PrimeGridFilterFormComponent } from './components/prime-grid-filter-form/prime-grid-filter-form.component';
import { PrimeGridFilterToolbarComponent } from './components/prime-grid-filter-toolbar/prime-grid-filter-toolbar.component';
import { SliderFilterComponent } from './components/slider-filter/slider-filter.component';
import { FilterSessionManagerService } from './services/filter-session-manager.service';
import { FilterSessionService } from './services/filter-session.service';
import { InitialFilterLoaderService } from './services/initial-filter-loader.service';

@NgModule({
  declarations: [
    ComboboxFilterComponent,
    DatepickerFilterComponent,
    DefaultTextfieldFilterComponent,
    SliderFilterComponent,
    DropdownFilterComponent,
    PrimeGridFilterFormComponent,
    GridFilterComponent,
    PrimeGridFilterToolbarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateDirective,
    TranslatePipe,
    DropdownModule,
    FieldModule,
    ButtonModule,
    SliderModule,
    ComboboxModule,
    SingleDropdownModule,
    MultipleDropdownModule,
    TagModule,
    PanelModule,
    UiCommonModule,
    DropDownAppkitOverlayListFixDirective,
  ],
  providers: [
    FilterSessionService,
    InitialFilterLoaderService,
    FilterSessionManagerService,
  ],
  exports: [
    PrimeGridFilterFormComponent,
    DropDownAppkitOverlayListFixDirective,
  ],
})
export class PrimeGridFiltersModule {}
